// ══════════════════════════════════════════════════════════════
// COMPASS – Country State Model
// ══════════════════════════════════════════════════════════════
import { CountryDto } from '../../api/models/country-dto';

export interface CountryState {
  countries: CountryDto[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialCountryState: CountryState = {
  countries: [],
  loading: false,
  loaded: false,
  error: null,
};
